export const VISUALISATION = {
  NONE: 'none',
  QUANTITY: 'quantity',
  CATEGORY: 'category'
} as const;
